import {Component, Input} from '@angular/core';
import {routesNames} from "@app/app-routing.module";

@Component({
  selector: 'app-empty-cart',
  templateUrl: './empty-cart.component.html',
  styleUrls: ['./empty-cart.component.scss']
})
export class EmptyCartComponent {

  routesNames = routesNames;

  @Input() isLoggedIn?:boolean | null;

}
